"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var config = {
    forms: {
        unsubscribe: {
            unsubscribeServiceHilfe: {
                fields: [
                    {
                        id: 'newsletter',
                        type: 'newsletter',
                        formType: 'radio',
                        checkedValue: 'unsubscribe|99',
                        subSelection: [
                            {
                                id: 'frq-daily',
                                type: 'frequency',
                                value: 0,
                                messageKey: 'newsletter.unsubscribe.form.typevalue.frequency.option.1',
                            },
                            {
                                id: 'frq-monthly',
                                type: 'frequency',
                                value: 3,
                                messageKey: 'newsletter.unsubscribe.form.typevalue.frequency.option.4',
                            },
                            {
                                id: 'unsubscribe',
                                type: 'unsubscribe',
                                value: 99,
                                messageKey: 'newsletter.unsubscribe.form.typevalue.unsubscribe',
                            },
                        ],
                    },
                    {
                        id: 'email',
                        type: 'email',
                        formType: 'email',
                        messageKey: 'newsletter.unsubscribe.form.email.label',
                        messageKeyPlaceholder: 'newsletter.unsubscribe.form.email.placeholder',
                    },
                ],
            },
        },
    },
};
exports.default = config;
//# sourceMappingURL=imwalkingde.js.map